/* IL CAPITANO — fix menu mobile overlay */
(function(){
  function update(){
    var header = document.getElementById('capHeader');
    var open = false;
    if (header) {
      open = !!header.querySelector('details[open], .menu-drawer-container[open], .menu-drawer-container.menu-opening');
    }
    document.documentElement.classList.toggle('cap-menu-open', open);
    document.body.classList.toggle('cap-menu-open', open);
  }

  function bind(){
    update();
    document.addEventListener('click', function(){ setTimeout(update, 40); }, true);
    document.addEventListener('keyup', update, true);
    document.addEventListener('keydown', update, true);

    var header = document.getElementById('capHeader');
    if (header && 'MutationObserver' in window) {
      new MutationObserver(update).observe(header, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['open', 'class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once:true });
  } else {
    bind();
  }
})();

/* Reset difensivo dei sottomenu: evita stati stretti/bloccati alla riapertura. */
(function(){
  function resetNested(drawer){
    if (!drawer) return;
    drawer.querySelectorAll('details details[open]').forEach(function(detail){
      detail.removeAttribute('open');
      detail.classList.remove('menu-opening');
    });
    drawer.querySelectorAll('.submenu-open').forEach(function(node){
      node.classList.remove('submenu-open');
    });
    var menu = drawer.querySelector('.menu-drawer');
    if (menu) menu.scrollTop = 0;
  }

  function bindReset(){
    var drawer = document.querySelector('#capHeader .menu-drawer-container');
    if (!drawer || drawer.dataset.capResetBound === 'true') return;
    drawer.dataset.capResetBound = 'true';

    drawer.addEventListener('toggle', function(){
      if (!drawer.open) resetNested(drawer);
    });

    window.addEventListener('pageshow', function(){
      if (!drawer.open) resetNested(drawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindReset, { once:true });
  } else {
    bindReset();
  }
})();
